import { Checkbox, Form, Input, Select } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { find } from 'lodash';
import { LoadingZone } from './LoadingZone';
import { RequestComments, ValidatedFormItem } from './RequestComments';
import { MarketingFileUpload } from './MarketingFileUpload';
import RequestSuWorkField from './RequestSuWorkField';

const { Option } = Select;
export const prepareSelectOptions = (list = []) => {
  return list.map(({ Name, Id }) => ({
    text: Name,
    value: Id,
  }));
};

export const PrepareSelect = ({ onChange, options, placeholder, defaultValue, disabledForm }) => {
  return (
    <Select
      defaultValue={defaultValue}
      onChange={(e) => onChange(e)}
      placeholder={placeholder}
      loading={!options.length}
      disabled={disabledForm}
    >
      {options.map(({ value, text }) => (
        <Option key={value}>{text}</Option>
      ))}
    </Select>
  );
};

function InfoCircleOutlined() {
  return null;
}

const RequestFormContentItem = ({ form, availableRequestFields, references, clickedSubmit }) => {
  const currentCategoryValue =
    availableRequestFields?.Type?.value ?? form.getFieldValue('Category');
  const currentServiceCategory =
    availableRequestFields?.Category?.value ?? form.getFieldValue('ServiceCategory');

  return {
    SuWork: (SuStartWork, SuEndWork) => {
      const startWork = SuStartWork || availableRequestFields?.SuStartWork;
      const endWork = SuEndWork || availableRequestFields?.SuEndWork;

      return (
        <RequestSuWorkField
          SuStartWork={startWork}
          SuEndWork={endWork}
          form={form}
          clickedSubmit={clickedSubmit}
          currentCategoryValue={currentCategoryValue}
          currentServiceCategory={currentServiceCategory}
        />
      );
    },
    ServiceCategory: (
      <Form.Item
        name="ServiceCategory"
        label="Категорія сервісу"
        validateTrigger={['onSubmit', 'onChange']}
        rules={[{ required: true, message: 'Вкажіть категорію сервісу' }]}
      >
        <PrepareSelect
          options={prepareSelectOptions(references?.ServiceCategory)}
          placeholder="Обрати"
          disabledForm={clickedSubmit}
        />
      </Form.Item>
    ),
    SuServiceSubCategory: (
      <Form.Item
        name="SuServiceSubCategory"
        label="Підкатегорія сервісу"
        validateTrigger={['onSubmit', 'onChange']}
        rules={[{ required: true, message: 'Вкажіть підкатегорію сервісу' }]}
      >
        <PrepareSelect
          defaultValue={availableRequestFields?.SuServiceSubCategory?.value}
          options={prepareSelectOptions(
            references?.SuServiceSubCategory?.filter(
              (subCat) =>
                !(
                  currentServiceCategory === '5369e6b8-4f16-45b3-8114-bdeeb2ca4969' &&
                  subCat.Name === 'Активності орендарів'
                )
            )
          )}
          placeholder="Обрати"
          disabledForm={clickedSubmit}
        />
      </Form.Item>
    ),
    Symptoms: <RequestComments label="Коментарі до звернення" disabled={clickedSubmit} placeholder="Вкажіть коментарі до звернення" />,
    SuPremise: (
      <Form.Item
        name="SuPremise"
        label="Виконавець"
        validateTrigger={['onSubmit', 'onChange']}
        rules={[{ required: true, message: 'Вкажіть виконавця' }]}
      >
        <PrepareSelect
          defaultValue={availableRequestFields?.SuPremise?.value}
          options={prepareSelectOptions(references?.SuPremise)}
          placeholder="Обрати"
          disabledForm={clickedSubmit}
        />
      </Form.Item>
    ),
    SuClaimCategory: (
      <Form.Item
        name="SuClaimCategory"
        label="Категорія скарги"
        validateTrigger={['onSubmit', 'onChange']}
        rules={[{ required: true, message: 'Вкажіть категорію скарги' }]}
      >
        <PrepareSelect
          defaultValue={availableRequestFields?.SuClaimCategory?.value}
          options={prepareSelectOptions(references?.SuClaimCategory)}
          placeholder="Обрати"
          disabledForm={clickedSubmit}
        />
      </Form.Item>
    ),
    SuClaimDepartment: (
      <Form.Item
        name="SuClaimDepartment"
        label="Департамент"
        validateTrigger={['onSubmit', 'onChange']}
        rules={[{ required: true, message: 'Вкажіть департамент' }]}
      >
        <PrepareSelect
          defaultValue={availableRequestFields?.SuClaimDepartment?.value}
          options={prepareSelectOptions(references?.SuClaimDepartment)}
          placeholder="Обрати"
          disabledForm={clickedSubmit}
        />
      </Form.Item>
    ),
    SuCarNumber: (
      <Form.Item
        name="SuCarNumber"
        label="Номер авто:"
        tooltip={{
          title: 'для автомобілів, які перебуватимуть на паркінгу від 30 до 60 хв',
          icon: <InfoCircleOutlined />,
        }}
      >
        <Input placeholder="Вкажіть номер авто" disabled={clickedSubmit} />
      </Form.Item>
    ),
    SuTenantResonsible: (
      <Form.Item
        name="SuTenantResonsible"
        label="Відповідальна особа заявника"
        validateTrigger={['onSubmit', 'onChange']}
        rules={[{ required: true, message: 'Вкажіть відповідальну особу заявника' }]}
      >
        <Input placeholder="Вкажіть відповідальну особу заявника" disabled={clickedSubmit} />
      </Form.Item>
    ),
    SuTelNumberTenant: (
      <Form.Item
        name="SuTelNumberTenant"
        label="Телефон відповідальної особи"
        validateTrigger={['onSubmit', 'onChange']}
        rules={[
          { required: true, message: 'Вкажіть телефон відповідального' },
          {
            validator: (_, value) => {
              if (!value) {
                return Promise.resolve(); // Поле пустое, пропускаем валидацию
              }
              if (!value.startsWith('+38')) {
                return Promise.reject(new Error('Номер повинен починатися з +38'));
              }

              // Пропускаем проверки, если номер введен не полностью
              if (value.length < 6) {
                return Promise.resolve(); // Пропускаем валидацию
              }

              const operatorCode = value.substring(3, 6); // Изменено: берем код оператора (три цифры после +38)

              if (!references || !references.MobileCodes) {
                console.warn('Отсутствует справочник MobileCodes');
                return Promise.resolve(); // Пропускаем валидацию, если нет справочника
              }

              const isValidOperatorCode = find(references.MobileCodes, { Code: operatorCode }); // Изменено: ищем по полю Code
              if (!isValidOperatorCode) {
                return Promise.reject(new Error('Невірний код оператора'));
              }
              if (value.length !== 13) {
                // Изменено: длина номера 12 символов с +38
                return Promise.reject(new Error('Номер повинен містити 12 цифр'));
              }
              return Promise.resolve();
            },
          },
        ]}
      >
        <Input
          placeholder="+380XXXXXXXX"
          disabled={clickedSubmit}
          maxLength={13} // Изменено: максимальная длина 12 символов
          onKeyPress={(e) => {
            const allowedChars = /^[0-9+]$/; // Разрешенные символы
            if (!allowedChars.test(e.key)) {
              e.preventDefault(); // Запрещаем ввод, если символ не соответствует
            }
          }}
          onChange={(e) => {
            // При изменении поля обновляем значение SuTelNumberTenant в форме
            form.setFieldsValue({ SuTelNumberTenant: e.target.value });
          }}
        />
      </Form.Item>
    ),
    SuLoadingZone: (
      <LoadingZone
        defaultValue={availableRequestFields?.SuLoadingZone?.value}
        requests={references}
        clickedSubmit={clickedSubmit}
        initialLoadingZone={form.getFieldValue('SuLoadingZone')}
      />
    ),
    RespNightWork: (
      <Form.Item
        name="RespNightWork"
        label="Виконавці робіт"
        rules={[{ required: true, message: 'Вкажіть виконавців робіт' }]}
      >
        <Input placeholder="Вкажіть виконавців робіт" />
      </Form.Item>
    ),
    MarketingFile: <MarketingFileUpload disabled={clickedSubmit} />,
    RespAltitudeWorks: (
      <Form.Item
        name="RespAltitudeWorks"
        valuePropName="checked"
        className="ant-form-item__checkbox"
      >
        <Checkbox disabled={clickedSubmit}>
          <span className="field__label">Роботи на висоті (драбина, вежа-тура тощо)</span>
        </Checkbox>
      </Form.Item>
    ),
    SuWorkDescription: (
      <ValidatedFormItem
        name="SuWorkDescription"
        label={
          currentServiceCategory === '88a699c2-b2de-4bde-9ffd-c038a9a174f9'
            ? 'Мета візиту'
            : 'Опис робіт'
        }
        placeholder={
          currentServiceCategory === '88a699c2-b2de-4bde-9ffd-c038a9a174f9'
            ? 'Вкажіть мету візиту'
            : 'Вкажіть опис робіт'
        }
        errorMessage={
          currentServiceCategory === '88a699c2-b2de-4bde-9ffd-c038a9a174f9'
            ? 'Вкажіть мету візиту'
            : 'Вкажіть опис робіт'
        }
        required={true}
        disabled={clickedSubmit}
        inputType="input"
        validateTrigger={['onSubmit', 'onChange']}
      />
    ),
    Agreement: (
      <Form.Item
        className="ant-form-item__checkbox"
        name="agreement"
        valuePropName="checked"
        validateTrigger={['onSubmit', 'onChange']}
        rules={[
          {
            validator: (_, value) =>
              value ? Promise.resolve() : Promise.reject(new Error('Обовʼязкове поле')),
          },
        ]}
      >
        <Checkbox>
          <span className="field__label">
            Я ознайомлений і погоджуюся з
            <a
              className="text-turquoise-normal-f16-l28"
              href="https://cms.respublikapark.com.ua/uploads/Pravila_TR_Cz_Respublika_Park_938d233bec.pdf"
              target="_blank"
              rel="noreferrer"
            >
              {' '}
              правилами{' '}
            </a>
            проведення робіт
          </span>
        </Checkbox>
      </Form.Item>
    ),
  };
};

export default RequestFormContentItem;
